import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const MYSQL = () => {
  return (
    <StartInterviewLayout type="mysql"/>
  )
}

export default MYSQL;